import DapDSFeedback from './feedback.component'

export * from './feedback.component'
export default DapDSFeedback

DapDSFeedback.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-feedback': DapDSFeedback
  }
}
